import styled from 'styled-components';

import Box from 'components/Box';

export const OriginalText = styled(Box)`
  font-size: 75%;
`;
